import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiParameterCollectionModule } from '@components/shared/ui-parameter-collection/ui-parameter-collection.module';
import { UiCronModule } from '@components/ui-cron/ui-cron.module';
import { UiDateTimePickerModule } from '@components/ui-datetime-picker/ui-datetime-picker.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { ProcessGridModule } from '@pages/process/grids';
import { TriggerUpsertModule } from '@pages/triggers/upsert/trigger.upsert.module';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSecondFormatModule } from '@uipath/angular/directives/ui-secondformat';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { TriggersPageComponent } from './triggers.page';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UiSuggestModule,
        UiDateTimePickerModule,
        SharedModule,
        UiCronModule,
        ProcessGridModule,
        UiParameterCollectionModule,
        UiGridModule,
        UiGridResetModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiDateFormatModule,
        UiSecondFormatModule,
        UiSpinnerButtonModule,
        UiNgLetModule,
        TriggerUpsertModule,
    ],
    declarations: [
        TriggersPageComponent,
    ],
    exports: [
        TriggersPageComponent,
    ],
    entryComponents: [
        TriggersPageComponent,
    ],
})
export class TriggerModule { }
